import Axios, { AxiosError } from "axios";
import Swal from "sweetalert2";
import { IUser } from "../pages/SignIn/interfaces";
import { AUTH_API, AXIOS_OPTIONS } from "./constants";

export const parseJwt = (token: string): any => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (error) {
        return { error: "No se encontró token" }
    }
}

export const logout = async (force?: boolean) => {
    const forceLogout = () => {
        if (force) {
            localStorage.removeItem('jwt');
            localStorage.removeItem('permisos');
            window.location.href = "/login";
        } else {
            const forceLogout = window.confirm('No fue posible cerrar sesión. ¿Desea forzar el cierre de sesión?');
            if (forceLogout) {
                localStorage.removeItem('jwt');
                localStorage.removeItem('permisos');
                window.location.href = "/login";
            }
        }
    }

    const api = `${AUTH_API}/usuarios/logout`;
    try {
        const res = await Axios.post(api, null, AXIOS_OPTIONS);
        if (res.status === 200) {
            localStorage.removeItem('permisos');
            localStorage.removeItem('jwt');
            window.location.href = "/login";
        } else {
            forceLogout();
        }
    } catch (err) {
        forceLogout();
    }
}

export const changePassword = async (idUsuario: number, usuario: any) => {
    try {
        const api = `${AUTH_API}/usuarios/${idUsuario}/password`;
        const resultado = (await Axios.put(api, usuario, AXIOS_OPTIONS));
        return resultado;
    } catch (error) {
        throw await handleAxiosError(error);
    }
}

export const getUser = () : IUser =>{
    const user: IUser =  parseJwt(localStorage.getItem("jwt") || "");
    return user;
}

export const handleAxiosError = async (err: AxiosError) => {
    // Manejo de errores genéricos.
    const error = err.response;
    if (error) {
        const status = error.status;
        const data = error.data.errors[0];
        // 1. En el caso de que regrese un error 401 (No autorizado):
        if (status === 401) {
            if (data.logout) return await logout(true);
        }
        // 2. En el caso de que regrese un error 500 (Error del servidor):
        if (status >= 500 && status <= 599){
            return Swal.fire({
                title: "Error de servidor",
                text: "Algo ha salido mal. Por favor, contacte al administrador del sistema",
                icon: "error",
                footer: `Error: ${data.msg}`
            })
        }

        // 3. En el caso de que regrese un error 400 (Error de solicitud):
        if (status >= 400 && status <= 499){
            return Swal.fire({
                title: "Error de solicitud",
                text: "La solicitud que realizó es incorrecta.",
                icon: "info",
                footer: `Error: ${data.msg}`
            })
        }
    }
}